import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ReplaySubject} from 'rxjs';

@Injectable({providedIn: 'root'})
export class TasksService {
    taskListSubject = new ReplaySubject(1);
    pdpListSubject = new ReplaySubject(1);

    tasksSubject = new ReplaySubject(1);

    constructor(private http: HttpClient) {
    }

    // general
    getUserCrm(userId) {
        return this.http.get('/agri/crm/getUserCrm?userId=' + userId);
    }

    getAllCRMUsers() {
        return this.http.get('agri/crm/getAllCRMUsers');
    }

    getSubordinateUsers() {
        return this.http.get('agri/crm/getSubordinateUsers');
    }


    isPDP(type) {return (type === 'pdp');}
    isTask(type) {return (type === 'task');}

    // Taskuri
    getMyAssignedTasks(type) {
        if (this.isPDP(type)) {
            return this.http.get('agri/crm/getMyAssignedPDPs');
        } else {
            return this.http.get('agri/crm/getMyAssignedTasks')
        }
    }

    getMyCreatedTasks(type) {
        if(this.isPDP(type)){
            return this.http.get('agri/crm/getMyCreatedPDPs');
        }else {
            return this.http.get('agri/crm/getMyCreatedTasks');
        }
    }

    createTask(task, type) {
        if(this.isPDP(type)){
            return this.http.post('agri/crm/createPDP', task);
        }else{
            return this.http.post('agri/crm/createTask', task);
        }
    }

    updateTask(task,taskId, type) {
        if(this.isPDP(type)){
            return this.http.put('agri/crm/updatePDP?personalDevelopmentId=' + taskId, task);
        }else{
            return this.http.put('agri/crm/updateTask?taskId=' + taskId, task);
        }
    }

    changeTaskStatus(taskId, newStatus, type) {
        if(this.isPDP(type)){
            return this.http.put('agri/crm/changePDPStatus?personalDevelopmentId=' + taskId + '&status=' + newStatus, {});
        }else{
            return this.http.put('agri/crm/changeTaskStatus?taskId=' + taskId + '&status=' + newStatus, {});
        }
    }

    respondToTask(taskId, message, type) {
        if(this.isPDP(type)){
            return this.http.put('/agri/crm/respondToPDP?personalDevelopmentId=' + taskId + '&message=' + message, {})
        }else{
            return this.http.put('/agri/crm/respondToTask?taskId=' + taskId + '&taskMessage=' + message, {})
        }
    }

    getTaskById(taskId, type) {
        if(this.isPDP(type)){
            return this.http.get('/agri/crm/getPDPById?personalDevelopmentId=' + taskId);
        }else {
            return this.http.get('/agri/crm/getTaskById?taskId=' + taskId);
        }
    }
}
